module.exports = __webpack_public_path__ + "static/media/info-os.deb932d9.svg";